// @flow
import * as React from 'react';

import { Button } from 'primitive-components';
import { Modal } from 'modal-components';
import { openModal } from 'modal-core-components';

import ReportsDownloadForm from './ReportsDownloadForm';

const formId = 'reportsDownloadForm';

type ReportsDownloadModalProps = {
  title: string,
  confirmButtonText: string,
  onClose: () => void,
} & React.ElementConfig<typeof ReportsDownloadForm>;

export default function openReportsDownloadModal({
  title,
  confirmButtonText,
  startDate,
  endDate,
  segmentCategories,
  segmentCategory,
  onSubmit,
}: ReportsDownloadModalProps) {
  return openModal(closeModal => (
    <Modal>
      <Modal.Header onClose={closeModal} title={title} />
      <Modal.Body>
        <ReportsDownloadForm
          id={formId}
          startDate={startDate}
          endDate={endDate}
          segmentCategories={segmentCategories}
          segmentCategory={segmentCategory}
          onSubmit={values => {
            onSubmit(values);
            closeModal();
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button form={formId} styleType="primary">
          {confirmButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  ));
}
